module.exports = __webpack_public_path__ + "img/mabat.b999edfa.svg";